import { colorCss } from "./colorCss";

/**
 * Canvas 2D version of bandRenderer.draw: the area under the polyline down
 * to `bottom`, filled with the same vertical gradient. Only the segments
 * over the canvas go into the path (they follow each other).
 *
 * @param {CanvasRenderingContext2D} context
 * @param {Float32Array} instances - [x0, y0, x1, y1] per segment of the upper edge
 * @param {number} floatsPerInstance
 * @param {object} params - see bandRenderer.draw
 */
export const paintBand = (
  context,
  instances,
  floatsPerInstance,
  { viewport, xTransform, yTransform, bottom, gradientRows, topColor, bottomColor },
) => {
  const [xScale, xOffset] = xTransform;
  const [yScale, yOffset] = yTransform;
  const [viewWidth] = viewport;
  const gradient = context.createLinearGradient(0, gradientRows[0], 0, gradientRows[1]);
  let lastX = null;

  gradient.addColorStop(0, colorCss(topColor));
  gradient.addColorStop(1, colorCss(bottomColor));
  context.beginPath();

  for (let offset = 0; offset < instances.length; offset += floatsPerInstance) {
    const fromX = instances[offset] * xScale + xOffset;
    const toX = instances[offset + 2] * xScale + xOffset;

    if (Math.max(fromX, toX) < 0 || Math.min(fromX, toX) > viewWidth) continue;

    if (lastX === null) context.moveTo(fromX, bottom);

    context.lineTo(fromX, instances[offset + 1] * yScale + yOffset);
    context.lineTo(toX, instances[offset + 3] * yScale + yOffset);
    lastX = toX;
  }

  if (lastX === null) return;

  context.lineTo(lastX, bottom);
  context.closePath();
  context.fillStyle = gradient;
  context.fill();
};
